/*
 * DRIVLY-UI React Components
 * @license MIT
 */
var n={left:0,top:0,right:0,gap:0},t=function(n){return parseInt(n||"",10)||0},i=function(i){if(void 0===i&&(i="margin"),"undefined"==typeof window)return n;var d=function(n){var i=window.getComputedStyle(document.body),d=i["padding"===n?"paddingLeft":"marginLeft"],e=i["padding"===n?"paddingTop":"marginTop"],r=i["padding"===n?"paddingRight":"marginRight"];return[t(d),t(e),t(r)]}(i),e=document.documentElement.clientWidth,r=window.innerWidth;return{left:d[0],top:d[1],right:d[2],gap:Math.max(0,r-e+d[2]-d[0])}};export{i as getGapWidth,n as zeroGap};
//# sourceMappingURL=utils.js.map
